<div class="searchbar" [ngClass]="{'opened': isMobileOverlayOpened}" #mainEl>
  <div class="searchbar__input-wrapper">
    <input class="searchbar__input"
           type="text"
           [placeholder]="placeholder"
           #searchEl
           enterkeyhint="go"
           [(ngModel)]="searchValue"
           (ngModelChange)="debouncedSearchValueUpdateTrigger()"
           (focusin)="onFocusIn()"
           (focusout)="onFocusOut()"
           (keyup)="onInputKeyUp($event)">

    <div class="searchbar__icon searchbar__icon--left searchbar__icon--search">
      <brt-icon [icon]="'search'"></brt-icon>
    </div>

    <div class="searchbar__icon searchbar__icon--right searchbar__icon--submit" *ngIf="actionIconType === 'submit'" (click)="submitFullTextSearch()">
      <brt-icon [icon]="'bold-arrow-right-circle'"></brt-icon>
    </div>

    <div class="searchbar__icon searchbar__icon--right searchbar__icon--clear" *ngIf="actionIconType === 'clear'" (click)="onClearIconClicked($event)">
      <brt-icon [icon]="'x-reg-circle'"></brt-icon>
    </div>

    <div class="searchbar__icon searchbar__icon--right searchbar__icon--filter" (click)="onFilterIconClicked($event)">
      <brt-icon [icon]="'filter'"></brt-icon>
    </div>

    <div class="searchbar__suggestions searchbar__suggestions--frequently" *ngIf="suggestionsType === SuggestionsType.FREQUENTLY">
      <div class="searchbar__suggestions-frequently-label">Wird oft gesucht</div>

      <div class="searchbar__suggestions-frequently-item" *ngFor="let frequentlyItem of frequentlySearchList">
        <brt-item-tag [title]="frequentlyItem" (itemClicked)="onFrequentlyItemClicked(frequentlyItem)"></brt-item-tag>
      </div>
    </div>

    <div class="searchbar__suggestions searchbar__suggestions--similar" *ngIf="suggestionsType === SuggestionsType.FILTER && filteredSuggestions.length > 0">
      <button role="button" class="searchbar__suggestions-similar-value" *ngFor="let suggestion of filteredSuggestions.slice(0, 5);" (click)="onSuggestionClicked(suggestion);">
        <div class="searchbar__suggestions-similar-value-icon"><brt-icon [icon]="suggestion.icon"></brt-icon></div>
        <div class="searchbar__suggestions-similar-value-text" [innerHTML]="suggestion.label"></div>
      </button>
    </div>
  </div>
</div>
